import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Fenzhan from '@/components/Fenzhan'
import FenDetail from '@/components/FenDetail'
import ZhaokaoMore from '@/components/ZhaokaoMore'
import ZhaokaoMoreDetail from '@/components/ZhaokaoMoreDetail'
import Dowmore from '@/components/Dowmore'
import Quesrionmore from '@/components/Quesrionmore'
import Quesrionmore_detail from '@/components/Quesrionmore_detail'
import Teachermore from '@/components/Teachermore'
import TeacherDetail from '@/components/TeacherDetail'
import CourseMore from '@/components/CourseMore'
import Coursedetail from '@/components/Coursedetail'
import Coursedetail_Bot from '@/components/Coursedetail_Bot' //线下课详情
import Aboutme from '@/components/Aboutme' //Aboutme
import Zixunmore from '@/components/Zixunmore'
import ZixunDetail from '@/components/ZixunDetail'
import Courdesystem from '@/components/Courdesystem'
import Courdesystem_detail from '@/components/Courdesystem_detail'
import Usercenter from '@/components/Usercenter'
import Calendarmore from '@/components/Calendarmore'
import Calendar_detail from '@/components/Calendar_detail'
import Dowload from '@/components/Dowload'
import bikaoMore from '@/components/bikaoMore'
import Logo from '@/components/Logo'
import serchList from '@/components/serchList'



Vue.use(Router)
    // export default new Router({

const router = new Router({
   
    routes: [{
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/serchList',
            name: 'serchList',
            component: serchList
        },
        {
            path: '/Fenzhan',
            name: 'Fenzhan',
            component: Fenzhan
        },
        {
            path: '/FenDetail',
            name: 'FenDetail',
            component: FenDetail
        }, {
            path: '/ZhaokaoMore',
            name: 'ZhaokaoMore',
            component: ZhaokaoMore
        },
        {
            path: '/ZhaokaoMoreDetail',
            name: 'ZhaokaoMoreDetail',
            component: ZhaokaoMoreDetail
        }, {
            path: '/Dowmore',
            name: 'Dowmore',
            component: Dowmore
        }, {
            path: '/Quesrionmore',
            name: 'Quesrionmore',
            component: Quesrionmore
        }, {
            path: '/Quesrionmore_detail',
            name: 'Quesrionmore_detail',
            component: Quesrionmore_detail
        }, {
            path: '/Teachermore',
            name: 'Teachermore',
            component: Teachermore
        }, {
            path: '/TeacherDetail',
            name: 'TeacherDetail',
            component: TeacherDetail
        },
        {
            path: '/CourseMore',
            name: 'CourseMore',
            component: CourseMore
        },
        {
            path: '/Coursedetail',
            name: 'Coursedetail',
            component: Coursedetail
        }, {
            path: '/bikaoMore',
            name: 'bikaoMore',
            component: bikaoMore
        },
        {
            path: '/Coursedetail_Bot',
            name: 'Coursedetail_Bot',
            component: Coursedetail_Bot
        }, {
            path: '/Aboutme',
            name: 'Aboutme',
            component: Aboutme
        }, {
            path: '/Zixunmore',
            name: 'Zixunmore',
            component: Zixunmore
        }, {
            path: '/ZixunDetail',
            name: 'ZixunDetail',
            component: ZixunDetail
        }, {
            path: '/Courdesystem',
            name: 'Courdesystem',
            component: Courdesystem
        },
        {
            path: '/Courdesystem_detail',
            name: 'Courdesystem_detail',
            component: Courdesystem_detail
        },
        {
            path: '/Usercenter',
            name: 'Usercenter',
            component: Usercenter
        },
        {
            path: '/Calendarmore',
            name: 'Calendarmore',
            component: Calendarmore
        }, {
            path: '/Calendar_detail',
            name: 'Calendar_detail',
            component: Calendar_detail
        }, {
            path: '/Dowload',
            name: 'Dowload',
            component: Dowload
        }, {
            path: '/Logo',
            name: 'Logo',
            component: Logo
        },




    ]
})


router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js